import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import Cookies from 'js-cookie';
import { STORAGE_KEYS } from '@/constants/StorageKeys';
const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        component: () => import('@/layouts/DashboardLayout.vue'),
        children: [
            {
                path: '/',
                name: 'home',
                component: () => import('../views/home/HomeView.vue'),
            },
            {
                path: '/video-calls',
                name: 'video-calls.manage',
                component: () => import('@/views/videoCalls/ManageVideoCallsView.vue'),
            },
            {
                path: '/packs',
                name: 'packs.manage',
                component: () => import('@/views/packs/ManagePacksView.vue'),
            },
            {
                path: '/packs/create',
                name: 'packs.create',
                component: () => import('@/views/packs/PackFormView.vue'),
            },
            {
                path: '/packs/edit/:uuid',
                name: 'packs.edit',
                component: () => import('@/views/packs/PackFormView.vue'),
            },
            {
                path: '/packs/:productId/upload',
                name: 'packs.upload',
                component: () => import('@/views/packs/ManageProductMediaView.vue'),
                props: true,
            },
            {
                path: '/payment-gateway-integrations',
                name: 'payment-gateway-integrations',
                component: () => import('@/views/paymentGatewayIntegrations/PaymentGatewayIntegrationsView.vue'),
            },
            {
                path: '/profile',
                name: 'profile',
                component: () => import('@/views/profile/ProfileView.vue'),
            },
            {
                path: '/media',
                name: 'media.manage',
                component: () => import('@/views/media/ManageMediaView.vue'),
            },
            {
                path: '/create-video-calls',
                name: 'create-video-calls',
                component: () => import('@/views/videoCalls/VideoCallFormView.vue'),
            },
            {
                path: '/create-video-calls/:uuid',
                name: 'create-video-calls.edit',
                component: () => import('@/views/videoCalls/VideoCallFormView.vue'),
            },
            {
                path: '/my-purchases',
                name: 'my-purchases',
                component: () => import('@/views/purchases/MyPurchasesView.vue'),
            },
            {
                path: '/my-purchases/:uuid',
                name: 'my-purchases.details',
                component: () => import('@/views/purchases/PurchaseDetailsView.vue'),
                props: true,
            },
            {
                path: '/my-purchases/content/:productUuid',
                name: 'my-purchases.content',
                component: () => import('@/views/purchases/ProductContentView.vue'),
                props: true,
            },
            {
                path: '/my-sales',
                name: 'my-sales',
                component: () => import('@/views/sales/MySalesView.vue'),
            },
            {
                path: '/security',
                name: 'security',
                component: () => import('@/views/security/SecurityView.vue'),
            },
            {
                path: '/subscriptions/plans',
                name: 'subscriptions.plans',
                component: () => import('@/views/subscriptions/ManagePlansView.vue'),
            },
            {
                path: '/white-label',
                name: 'white-label',
                component: () => import('@/views/whitelabel/WhiteLabelView.vue'),
            },
            {
                path: '/checkouts',
                name: 'checkouts',
                component: () => import('@/views/checkoutBuilder/ManageCheckoutsView.vue'),
            },
            {
                path: '/checkout-builder/:id',
                name: 'checkout-builder',
                component: () => import('@/views/checkoutBuilder/CheckoutBuilderView.vue'),
            },
            {
                path: '/tracking-profiles',
                name: 'tracking-profiles',
                component: () => import('@/views/organizations/tracking-profiles/TrackingProfilesView.vue'),
            },
        ],
    },
    {
        path: '/login',
        component: () => import('@/views/auth/LoginView.vue'),
        name: 'login',
    },
    {
        path: '/v2/login',
        name: 'customer.login',
        component: () => import('@/views/checkout/CustomerLoginView.vue'),
    },
    {
        path: '/register',
        component: () => import('@/views/auth/RegisterView.vue'),
        name: 'register',
    },
    {
        path: '/checkout',
        name: 'checkout',
        component: () => import('@/views/checkout/PackCheckoutView.vue'),
    },
    {
        path: '/checkout/video/:uuid',
        component: () => import('@/views/checkout/CheckoutView.vue'),
        name: 'video-checkout',
    },
    {
        path: '/checkout/video/:uuid/call',
        component: () => import('@/views/checkout/VideoPaidCheckoutView.vue'),
        name: 'video-call',
    },
    {
        path: '/checkout/video/:uuid/preview',
        component: () => import('@/views/checkout/VideoPaidCheckoutView.vue'),
        name: 'video-preview',
    },
    {
        path: '/v2/:uuid',
        name: 'public-checkout-v2',
        component: () => import('@/views/checkout/PublicCheckoutView.vue'),
    },
    {
        path: '/checkout/success/:uuid',
        name: 'checkout-success',
        component: () => import('@/views/checkout/CheckoutSuccessView.vue'),
        props: true,
    },
    {
        path: '/purchases/:uuid',
        name: 'purchases.public.details',
        component: () => import('@/views/checkout/CheckoutSuccessView.vue'),
        props: true,
    },
    {
        path: '/organizations',
        name: 'organizations',
        component: () => import('@/views/organizations/OrganizationsView.vue'),
    },

    {
        path: '/organizations/create',
        name: 'organizations.create',
        component: () => import('@/views/organizations/CreateOrganizationView.vue'),
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

router.beforeEach((to, from, next) => {
    const publicRoutes = [
        'login',
        'register',
        'video-checkout',
        'video-call',
        'checkout',
        'landing-demo',
        'public-checkout-v2',
        'customer.login',
        'checkout-success',
        'purchases.public.details',
    ];

    let token = Cookies.get(STORAGE_KEYS.TOKEN);

    if (!token) {
        token = localStorage.getItem(STORAGE_KEYS.TOKEN) || undefined;
    }

    let organization = Cookies.get(STORAGE_KEYS.ORGANIZATION);

    if (!organization) {
        organization = localStorage.getItem(STORAGE_KEYS.ORGANIZATION) || undefined;
    }

    if (publicRoutes.includes(to.name as string)) {
        next();
        return;
    }

    if (!token) {
        next({ name: 'login' });
        return;
    }

    if (to.name !== 'organizations' && to.name !== 'organizations.create' && !organization) {
        next({ name: 'organizations' });
        return;
    }

    next();
});

export default router;
